/**
 * Font Size Constants
 */
export const fontSizes = {
  xsmall: '10px',
  small: '12px',
  medium: '14px',
  large: '16px',
  xlarge: '20px',
};

/**
 * Font Weight Constants
 */
export const fontWeights = {
  regular: 400,
  semibold: 500,
  bold: 600,
};

/**
 * Spacing Constants
 */
export const spacing = {
  none: '0',
  xxsmall: '4px',
  xsmall: '8px',
  small: '12px',
  medium: '16px',
  large: '24px',
  xlarge: '32px',
  xxlarge: '48px',
};

/**
 * CSS Media Queries for breakpoints
 * For reference:
 * max-width: screen size <= breakpoint
 * min-width: screen size > breakpoint
 */

/**
 * Query for screens more than 768px wide
 */
export const desktopMediaQuery = '@media(min-width: 768px)';

/**
 * Query for screens 768px wide or less
 */
export const mobileMediaQuery = '@media(max-width: 768px)';
